import { MARQUEE_WORDS } from "@/lib/site";

export default function Marquee() {
  const set = (ariaHidden) =>
    MARQUEE_WORDS.map((w, i) => (
      <span key={`${w}-${i}`} className="flex items-center gap-8 pr-8" aria-hidden={ariaHidden || undefined}>
        <span className="whitespace-nowrap font-serif text-2xl font-light text-charcoal/70 sm:text-3xl">
          {w}
        </span>
        <span className="h-1.5 w-1.5 rotate-45 bg-river/60" aria-hidden="true" />
      </span>
    ));

  return (
    <div className="overflow-hidden border-y border-charcoal/10 bg-mist py-6" data-testid="values-marquee">
      <div className="flex w-max animate-marquee">
        <div className="flex">{set(false)}</div>
        <div className="flex">{set(true)}</div>
      </div>
    </div>
  );
}
